import { Container } from '@mui/system'
import React from 'react'
function Terminos() {
  return (
    <>
    <Container>
    
<h1>Términos y Condiciones del Sistema de Sorteos</h1>

<p>¡Bienvenido al sistema de sorteos para los comercios de nuestra ciudad, A continuación, te presentamos los términos y condiciones que debes conocer antes de participar: </p>

<h2>Registro de Comercios: </h2>

<p>a. Los comerciantes interesados en participar deberán registrarse en nuestra página web utilizando un nombre de usuario y contraseña. </p>

<p>b. Durante el registro, los comercios deben proporcionar la siguiente información: nombre de fantasía del comercio, dirección completa (calle y número), número de CUIT, razón social, centro comercial al que pertenecen, correo electrónico, nombre de contacto, si son socios de la Cámara o Asociación Empresaria (sí o no). Los datos suministrados serán almacenados en el sitio web de las entidades participantes, Federación, Cámaras o Asociaciones empresarias correspondiente a la ciudad. </p>

<p>c. Cada comercio recibirá un código QR único generado por nuestro sistema. Incluso si varias sucursales de una empresa tienen el mismo número de CUIT, cada dirección tendrá su propio código QR. Los comercios deben imprimir el código QR y exhibirlo en un lugar visible dentro de su local. </p>

<p>d. El público podrá participar sin obligación de compra.
Las entidades comprarán los vouchers al comercio ganador, este entregará una factura a nombre de la entidad y el ganador gastará el valor del voucher en dicho comercio. No es canjeable por dinero en efectivo. </p>

<p>f. Adicionalmente, los comercios podrán aportar obsequios, órdenes de compra y bonos en cada campaña. Las promociones serán publicadas en el sitio web oficial de las entidades previamente al comienzo. </p>

<h2>Participación del Público: </h2>
<p>a. Las personas que visiten los comercios participantes podrán escanear el código QR generado por cada establecimiento. </p>

<p>b. Al escanear el código QR, serán redirigidos a una sección de la página web donde deberán completar la siguiente información al registrarse por primera vez: correo electrónico, número de teléfono y número de DNI. </p>

<p>c. Se podrá participar en varios comercios de forma simultánea una sola vez al día. </p>

<h2>Sorteos: </h2>
<p>a. Los participantes que se hayan registrado correctamente tendrán la oportunidad de participar en los sorteos. </p>

<p>b. Los sorteos se llevarán a cabo a través del sistema interno/software que seleccionará a los ganadores de manera aleatoria. </p>

<p>c. Los ganadores serán notificados por correo electrónico o mediante otro medio de contacto proporcionado durante el registro. </p>

<p>d. Los premios principales serán publicados en la página web de las entidades y consistirán en órdenes de compra en aquellos comercios donde se haya leído el código QR. </p>

<p>e. El detalle de premios y condiciones particulares están disponibles en el enlace web correspondiente para cada localidad participante.Se encuentraimpreso al pie del Código QR de los comercios participantes. </p>

<h2>Protección de Datos Personales: </h2>
<p>a. Toda la información proporcionada durante el registro será tratada de manera confidencial. </p>

<p>b. No compartiremos los datos personales con terceros sin el consentimiento expreso de los participantes.
Al participar en nuestros sorteos, acepta cumplir con los términos y condiciones establecidos anteriormente. Te invitamos a leer detenidamente esta información antes de participar. La entidadse reserva el derecho de cambiar estas condiciones y será el único autorizado que resuelva las posibles controversias que puedan surgir. </p>

<p>Si tiene alguna pregunta o inquietud, no dude en contactarnos a través de nuestra página web o utilizando los datos de contacto proporcionados. </p>

<p>¡Buena suerte en los sorteos y gracias por formar parte de nuestro sistema! </p>



    <br />
    </Container>
    </>
  )
}

export default Terminos